var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-result',{attrs:{"status":"404","title":"404","sub-title":"页面不存在"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.backHome}},[_vm._v(" 返回首页 ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }